import { render } from "./TelegramIntegration.vue?vue&type=template&id=2836c843"
import script from "./TelegramIntegration.vue?vue&type=script&lang=js"
export * from "./TelegramIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__